<template>
    <div class="container" :class="{ 'androidMode': isAndroidMode() }">
        <h1>{{ getString('pedido_para') }}</h1>
        <div class="mode-container">
            <div class="mode" v-if="modeEntrega.find(e => e === 'comer')" @click="chooseModoEntrega('comer')">
                <img :src="imgComerAqui">
                <span v-text="getString('comer_aqui')"></span>
            </div>
            <div class="mode" v-if="modeEntrega.find(e => e === 'levar')" @click="chooseModoEntrega('levar')">
                <img :src="imgToGo">
                <span v-text="getString('viagem')"></span>
            </div>
        </div>
    </div>
</template>

<script>

import Util from '@/assets/libs/util'
import LocaleController from '@/assets/controllers/LocaleController'
import ClarityController from '@/assets/controllers/ClarityController'

export default {
    name: 'ModeEntrega',
    data () {
        return {
            modeEntrega: [],
            imgToGo: Util.getConfigImage('toGo') || require('../../static/icons/viagem.jpg'),
            imgComerAqui: Util.getConfigImage('comerAqui') || require('../../static/icons/comer.jpg')
        }
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        chooseModoEntrega: function (value) {
            Util.setLocalVar('modoentrega', value)
            value === 'levar' ? ClarityController.event('pedido_para_levar') : ClarityController.event('pedido_consumo_local')
            this.$emit('hideModoEntrega')
        },
        isAndroidMode: function () {
            return Util.isAndroidMode()
        }
    },
    mounted () {
        let config = Util.getLocalVar('taaconfig')
        this.modeEntrega = config['modeEntrega']
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@import (reference) url("../assets/common.less");

.position {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}

.container {
    .position;
    background: rgba(0, 0, 0, 0.3);
    z-index: 100;

    h1 {
        position: absolute;
        left: 50%;
        top: 38%;
        z-index: 1;
        display: block;
        text-align: center;
        transform: translate(-50%, -50%);
        font-size: 3em;
        background: white;
        padding: 10px;
    }

    .mode-container {
        .position;
        margin: auto;
        height: 280px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: white;
        padding: 110px 0;

        .mode {
            padding: 5px;
            box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
            display: inline-block;
            margin: 0 50px -40px 50px;
        }

        img {
            width: 280px;
            height: 280px;
            margin: auto;
            display: block;
        }

        span {
            padding-top: 5px;
            font-size: 2.5rem;
            text-align: center;
            display: block;
        }
    }
}

@media (min-width: 699px) and (max-width: 1025px) {
    .container {
        h1 {
            font-size: 2.1em;
            top: 35%;
            width: 100%;
        }
        .mode-container {
            height: 230px;
            span {
                padding-top: 5px;
                font-size: 2rem;
            }

            img {
                width: 230px;
                height: 230px;
            }
        }
    }
}

@media (max-width: 698px) {
    .container {

        // Gertec SK210
        h1 {
            font-size: 1.9em;
            top: 32%;
            width: 100%;
        }

        .mode-container {
            height: 260px;
            padding: 50px 0;
            .mode {
                box-shadow: 1px 0px 5px rgba(0, 0, 0, 0.1);
                span {
                    padding-top: 5px;
                    font-size: 1.4rem;
                }

                img {
                    width: 150px;
                    height: 150px;
                }
            }
        }
    }
}
@media (orientation: landscape) {
    .container {
        h1 {
            font-size: 2.1em;
            top: 32%;
            width: 100%;
        }

        .mode-container {
            height: 260px;
            padding: 50px 0;
            span {
                padding-top: 5px;
                font-size: 2rem;
            }

            img {
                width: 170px;
                height: 170px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ModeEntrega.vue